import { z } from "zod";

export const ACCESSIONING_NOTES_MAX_LENGTH = 10_000;

/** True when HTML is null/blank or only empty Squire/editor markup. */
export function isEmptyAccessioningNotesHtml(
  html: string | null | undefined,
): boolean {
  if (html == null) return true;
  const text = html
    .replace(/<br\s*\/?>/gi, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();
  return text.length === 0;
}

export const accessioningNotesField = z
  .string()
  .max(ACCESSIONING_NOTES_MAX_LENGTH)
  .nullish()
  .transform((value) => {
    if (value == null) return null;
    return isEmptyAccessioningNotesHtml(value) ? null : value;
  });
